// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__TV1nM","header":"ReportDetails_header__r3stY","title":"ReportDetails_title__2f1if","left":"ReportDetails_left__1fONt"};